/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SharedModule
 */

import {
    Component,
    ElementRef,
    Input,
} from '@angular/core';
import { FocusableOption } from '@angular/cdk/a11y';

/**
 * @description
 *     Component wrapper around a dropdown button item that implements the FocusableOption so that
 *     it can be managed using the FocusKeyManager.
 * @author alextsg
 */
@Component({
    selector: 'avi-dropdown-button-item',
    template: '{{ label }}',
    host: {
        tabindex: '-1',
        role: 'list-item',
    },
})
export class AviDropdownButtonItemComponent implements FocusableOption {
    /**
     * Text shown for the dropdown item.
     */
    @Input()
    public label: string;

    /**
     * Used by FocusKeyManager in parent component to determine if option should be skipped.
     */
    @Input()
    public shouldSkip = false;

    constructor(private elementRef: ElementRef) {}

    /**
     * Focus element. Used by FocusKeyManager in parent component.
     */
    public focus(): void {
        this.elementRef.nativeElement.focus();
    }
}
